import { Icon } from '@iconscout/react-unicons';
import { ReactNode } from 'react';
import { cn } from '../../lib/helpers.ts';

interface FeatureListItemProps {
    icon: Icon;
    title: string | ReactNode;
    description?: string | ReactNode;
}

export function FeatureListItem({
    icon: Icon,
    title,
    description,
}: FeatureListItemProps) {
    return (
        <li className="flex items-start space-x-4">
            {/*<Icon size={20} className="mt-0.5 shrink-0" />*/}
            <div className="mt-[3px] flex size-8 shrink-0 items-center justify-center rounded-lg bg-product-100">
                <Icon className="text-product-800" size={20} />
            </div>
            <div>
                <h3 className="mb-0 block text-lg font-semibold">{title}</h3>
                {description && (
                    <p className="!mt-0.5 italic text-ink-800">{description}</p>
                )}
            </div>
        </li>
    );
}

interface FeatureListQuoteProps {
    author: string | ReactNode;
    title: string | ReactNode;
    description?: string | ReactNode;
    isLeft?: boolean;
}

export function FeatureListQuote({
    author,
    title,
    description,
    isLeft = true,
}: FeatureListQuoteProps) {
    return (
        <div className={cn('sm:w-3/4', isLeft ? 'me-auto' : 'ms-auto')}>
            <div className="rounded-xl bg-product-100/50 p-4">
                <h3 className="mb-0 block text-lg font-semibold">{title}</h3>
                {description && (
                    <p className="!mt-0.5 italic text-ink-800">{description}</p>
                )}
                <p className="mt-2 text-right text-sm font-semibold text-ink-800">
                    <span className="me-1.5">&mdash;</span>
                    <span>{author}</span>
                </p>
            </div>
            <div
                className={cn('flex', isLeft ? 'justify-start' : 'justify-end')}
            >
                <div
                    className={cn(
                        'relative size-0',
                        'border-l-[12px] border-r-[12px] border-t-[12px] border-l-transparent border-r-transparent border-t-product-100/50',
                        'mx-4'
                    )}
                ></div>
            </div>
        </div>
    );
}
